import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { FxRateDto, FxRateFilter } from "@/features/ledger/api/dto";

/** Historique des taux de change par couple de devises (`POST /FxRates/all`, guide §4.2). */
export const useFxRates = (
  params: ListRequest<FxRateFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_FX_RATES_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.fxRates.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<FxRateDto>>,
    enabled,
  });
